import { render, staticRenderFns } from "./VehicleProvisionStatistics.vue?vue&type=template&id=b02efa46&"
import script from "./VehicleProvisionStatistics.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QBtn,QTooltip,QSpace,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QSelect,QBtn,QTooltip,QSpace,QInnerLoading,QSpinnerGears}, component.options.components || {})
